const BASE_ROUTE = "/billing";

export const BILLING_ROUTE = {
  BASE: BASE_ROUTE,
  CHANGE_SUBSCRIPTION: `${BASE_ROUTE}/change-subscription`,
  UPGRADE_SUBSCRIPTION: `${BASE_ROUTE}/upgrade-subscription/:subscriptionId`,
} as const;
